class TrieNode {
  children: Map<string, TrieNode>; // 자식 노드들을 저장하는 맵
  isEndOfWord: boolean; // 현재 노드가 단어의 끝인지 여부
  word: string; // 현재 노드가 단어의 끝인 경우, 해당 단어를 저장

  constructor() {
    this.children = new Map();
    this.isEndOfWord = false;
    this.word = '';
  }
}

export class Trie {
  root: TrieNode;

  constructor() {
    this.root = new TrieNode();
  }

  insert(word: string): void {
    let current = this.root;
    const lowerWord = word.toLowerCase();

    for (const char of lowerWord) {
      if (!current.children.has(char)) {
        current.children.set(char, new TrieNode());
      }
      current = current.children.get(char)!;
    }
    current.isEndOfWord = true;
    current.word = word; // 원본 단어 저장
  }

  search(prefix: string): string[] {
    const result: string[] = [];
    let current = this.root;
    const lowerPrefix = prefix.toLowerCase();

    // prefix로 시작하는 노드까지 이동
    for (const char of lowerPrefix) {
      const childNode = current.children.get(char);
      if (!childNode) {
        return result;
      }
      current = childNode;
    }
    // 정확히 일치하는 단어가 있으면 바로 반환
    if (current.isEndOfWord) {
      return [current.word];
    }
    // prefix로 시작하는 모든 단어 수집
    this.collectWords(current, result);
    return result;
  }
  // 하위 노드들 endofword까지 DFS 탐색해서 전체 word 배열 반환
  private collectWords(node: TrieNode, result: string[]): void {
    if (node.isEndOfWord) {
      result.push(node.word);
    }

    for (const child of Array.from(node.children.values())) {
      this.collectWords(child, result);
    }
  }
}
